import {Text, View} from '@react-pdf/renderer'
import {styles} from './Styles'
import PropTypes from 'prop-types'
import theme from '../../../../../themes/pTheme/pTheme'

const PersonaLegend = ({personas, personasConfig, personaPercentage}) => {
  // Sort personas by percentage in descending order
  const sortedPersonas = [...personas].sort((a, b) => {
    const percentageA = personaPercentage.find((p) => p.persona === a)?.percentage || 0
    const percentageB = personaPercentage.find((p) => p.persona === b)?.percentage || 0
    return percentageB - percentageA
  })

  return (
    <View style={styles.personaLegendContainer}>
      <Text style={styles.personaLegendTitle}>Persona Legends</Text>
      <View style={styles.personaLegendContainerRow}>
        {sortedPersonas.map((persona) => {
          const updatedName = personasConfig?.customPersonaNames?.find(
            (name) => name?.persona === persona.trim()
          )?.customName
          const color =
            theme.palette.personaColor?.[personasConfig?.personas?.[persona]]?.[0] || theme.palette.hpAccentBlack
          const percentage = personaPercentage.find((p) => p.persona === persona)?.percentage || 0
          const displayPercentage = percentage < 1 ? '<1%' : `${percentage}%` // Handle percentages less than 1%
          return (
            <View key={persona} style={styles.personaLegendItemRow}>
              <View style={{...styles.personaLegendDot, backgroundColor: color}} />
              <Text style={styles.textRegular}>{updatedName || persona} </Text>
              <Text style={styles.boldText}>{displayPercentage}</Text>
            </View>
          )
        })}
      </View>
    </View>
  )
}

PersonaLegend.propTypes = {
  personas: PropTypes.arrayOf(PropTypes.string).isRequired,
  personasConfig: PropTypes.object.isRequired,
  personaPercentage: PropTypes.arrayOf(
    PropTypes.shape({
      persona: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
      personaCount: PropTypes.number.isRequired
    })
  ).isRequired
}

export default PersonaLegend

/**
 * List of functions and their purpose:
 *
 * - PersonaLegend: Renders a legend displaying personas with their associated colors and percentages, sorted in descending order.
 */
